import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, NgZone } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';

import { DomSanitizer, SafeResourceUrl, } from '@angular/platform-browser';
import { AppService } from '../app.service';
import { LookupList, ILookup } from '../shared/lookup';
import { MessageBrokerService } from '../shared/core/message-broker.service';
import { ProjectItem } from '../project/index';
import { IReportItem } from './reports-Item.model';
import { ReportsService } from './reports.service';
import { ReportBuilder } from './reports-builder.model';
import { GlobalErrorHandler } from '../shared/core/error-handler';
import { SharedUtils, DateUtils } from '../shared/utils';

import { NotificationsService, Notification } from '../shared/helper-components/index';
import { PromptOptions, ModalPromptService } from '../shared/helper-components/modal-prompt.service';
import { ClearanceItemTagComponent } from '../clearance-item';
import { CITag } from '../clearance-item/clearance-item.model';
import { FormGroup } from '../../../node_modules/@angular/forms';
import { FileDownloadService } from '../shared/helper-components/file-download.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../shared/core/index';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';

@Component({
  selector: 'reports',
  standalone: false,
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']

})
export class ReportsComponent implements OnInit {

    @ViewChild('maincontainer', { static: false }) public maincontainer: ElementRef;
    @ViewChild('tagComponent', { static: false }) tagComponent: ClearanceItemTagComponent;
    @ViewChild(CdkTextareaAutosize, { static: false }) customHeaderAutosize: CdkTextareaAutosize;

    private projectChangesSubscription: Subscription;
    private scrollBottomReachedSubscription: Subscription;

    showSpinner: boolean;
    content: SafeResourceUrl;
    reportParams: ReportBuilder;
    statusLookup: ILookup[] = [];
    restrictionsLookup: ILookup[] = [];
    isLoadingMoreRecords: boolean = false;
    reportItemMessage: string;
    reportItemMessageTitle: string;
    includeAllTags: boolean = false;
    isLoadingFilterTags: boolean = false;
    globalTags: CITag[] = [];
    mobileFiltersExpanded: boolean = false;

    MASTER_REPORT_NAME = 'masterReport';
    MASTER_REPORT_HORIZONTAL_NAME = 'masterReportHorizontal';
    MASTER_REFERENCE_REPORT_NAME = 'masterReferenceReport';
    END_CREDITS_REPORT_NAME = 'endCreditsReport';
    objectKeys = Object.keys;
    reports: { [type: string]: string } = {
        masterReport: 'Master',
        masterReferenceReport: 'Master With Reference',
        masterReportHorizontal: 'Master Horizontal',
        endCreditsReport: 'Distribution Memos'
    };
    REPORT_GENERATED_SUCCESSFULLY = 1;
    REPORT_GENERATION_IN_PROGRESS = 0;
    REPORT_WITH_ERROR = -1;
    private readonly REPORTS_PAGE_SIZE = 12;
    constructor(
        private _appService: AppService, public sanitizer: DomSanitizer,
        private _messageBrokerService: MessageBrokerService,
        private _reportService: ReportsService,
        private _errorHandler: GlobalErrorHandler,
        private _prompt: ModalPromptService,
        private _notificationsService: NotificationsService,
        private _fileDownloadService: FileDownloadService,
        private _authService: AuthService,
        private _http: HttpClient,
        private _dialog: MatDialog,
        private ngZone: NgZone,
        private cd: ChangeDetectorRef) {
    }
    public ngOnInit() {
        //console.log(`Reports: ${ JSON.stringify(this.reports)}: ${Object.keys(this.reports)[0]}` );

        this.reportParams = new ReportBuilder();
        this.reportParams.reportName = Object.keys(this.reports)[0];
        this.reportParams.restrictionType = 'Notes';
        this.reportParams.sortedBy = '';
        this.reportParams.status = 'All';
        this.reportParams.sortDirection = 'ASC';
        this.reportParams.searchBy = 'All';
        this.reportParams.searchByValue = '';
        this.reportParams.reports = [];
        this.reportParams.pageSize = this.REPORTS_PAGE_SIZE;
        this.reportParams.pageStartIndex = 0;
        this.reportParams.totalNumberOfRecords = 0;
        this.reportParams.includeTheseTags = [];
        this.reportParams.excludeTheseTags = [];
        this.reportParams.isCustomHeaderSelected=false;
        this.reportParams.customHeader='';
        this.reportParams.asOfDate=null;
        this.reportParams.reports = new Array<IReportItem>();     
        this.subScribeProjectNameChanges();
        this.scrollBottomReachedSubscription = this._appService.scrollBottomReachedEvent.subscribe(() => {
            this.loadMoreRecords();
        });

    }
    ngOnDestroy() {
        this.projectChangesSubscription.unsubscribe();
        if (this.scrollBottomReachedSubscription) {
            this.scrollBottomReachedSubscription.unsubscribe();
        }
    }
    ngAfterViewInit() {
        SharedUtils.RemoveTooltipIfNeeded();
        if (SharedUtils.IsMobile()) {

            this.openFirst();
            setTimeout(() => {
                this.closeFirst();
            }, 1500);
        }
        SharedUtils.FixFlickering();
    }

    get IsMobile(){
        return SharedUtils.IsMobile();
    }

    openFirst() {
        this.mobileFiltersExpanded = true;
    }

    closeFirst() {
        this.mobileFiltersExpanded = false;
    }
    subScribeProjectNameChanges(): void {
        this.projectChangesSubscription = this._messageBrokerService.getCurrentProject().subscribe((project: ProjectItem) => {
            if (project != null && project.ProjectId) {
                let openedProject = project;
                this.reportParams.projectId = project.ProjectId;
                this.loadCILookups(project.ProjectId);
                this.refreshReportsList();
                setTimeout(() => this.syncFilterTagsWithProject());
            }
        });
    }


    manualLoad(): void {
        this.loadMoreRecords();
        setTimeout(() => {
            this.maincontainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        });
    }

    moreRecords(): boolean {
        if (this.isLoadingMoreRecords || !this.reportParams) {
            return false;
        }

        const loadedCount = this.reportParams.reports ? this.reportParams.reports.length : 0;
        if (loadedCount >= 2000) {
            return false;
        }

        const total = this.reportParams.totalNumberOfRecords;
        if (total != null && total > 0) {
            return total > loadedCount;
        }

        // API may return PageSize/TotalNumberOfRecords as 0; treat a full page as "maybe more".
        const pageSize = this.reportParams.pageSize || this.REPORTS_PAGE_SIZE;
        return loadedCount > 0 && loadedCount % pageSize === 0;
    }

    loadMoreRecords(): void {
        if (!this.isLoadingMoreRecords && this.reportParams && this.reportParams.projectId && this.moreRecords()) {
            const nextPageRecordStartIndex = this.reportParams.reports.length;
            this.isLoadingMoreRecords = true;
            this.reportParams.pageStartIndex = nextPageRecordStartIndex;
            const loadedBeforeRequest = this.reportParams.reports.length;
            var reportGenerateParams = this.getRequestParams();
            this._reportService.getReportsList(reportGenerateParams)
                .subscribe(
                    (data) => {
                        this.ngZone.run(() => {
                            this.isLoadingMoreRecords = false;
                            if (data.reports) {
                                this.applyPaginationFromResponse(data.pageSize, data.totalNumberOfRecords);
                                this.appendReportsWithoutDuplicates(data.reports);
                                this.reportParams.pageStartIndex = this.reportParams.reports.length;

                                if (this.reportParams.reports.length === loadedBeforeRequest) {
                                    this.reportParams.totalNumberOfRecords = this.reportParams.reports.length;
                                } else if (data.reports.length < this.reportParams.pageSize) {
                                    this.reportParams.totalNumberOfRecords = this.reportParams.reports.length;
                                }
                            }
                            this.scheduleReportsViewRefresh();
                        });
                    },
                    (error: any) => {
                        this.ngZone.run(() => {
                            this.processError(error);
                            this.scheduleReportsViewRefresh();
                        });
                    }
                );

        }
    }

    private appendReportsWithoutDuplicates(reports: IReportItem[]): void {
        if (!reports || reports.length === 0) {
            return;
        }

        const existingIds = new Set(this.reportParams.reports.map(report => report.reportId));
        reports.forEach(report => {
            if (!existingIds.has(report.reportId)) {
                this.reportParams.reports.push(report);
                existingIds.add(report.reportId);
            }
        });
    }

    private applyPaginationFromResponse(pageSize: number, totalNumberOfRecords: number): void {
        this.reportParams.pageSize = this.REPORTS_PAGE_SIZE;
        if (totalNumberOfRecords != null && totalNumberOfRecords >= 0) {
            this.reportParams.totalNumberOfRecords = totalNumberOfRecords;
        }
    }

    private applyReportsList(res: ReportBuilder): void {
        if (!res || !res.reports) {
            this.reportParams.reports = [];
            this.showSpinner = false;
            return;
        }

        this.applyPaginationFromResponse(res.pageSize, res.totalNumberOfRecords);
        if (res.reportPrivilegedNotes && res.reportPrivilegedNotes.length > 0) {
            this.reportParams.isCustomHeaderSelected = true;
            this.reportParams.customHeader = res.reportPrivilegedNotes.split('<br>').join('\n');
            if (!this.reportParams.asOfDate) {
                this.reportParams.asOfDate = new Date();
            }
            this.scheduleCustomHeaderResize();
        }

        this.reportParams.reports = res.reports.map(it => {
            it.toolTipSearchByDelay = 5000;
            it.toolTipStatusDelay = 5000;
            return it;
        });
        this.reportParams.pageStartIndex = this.reportParams.reports.length;
        this.showSpinner = false;
    }

    private scheduleReportsViewRefresh(): void {
        queueMicrotask(() => {
            this.ngZone.run(() => this.cd.detectChanges());
        });
    }
    processError(error: any) {
        this.isLoadingMoreRecords = false;
        if (error.status == 404) {

        } else {
            this._errorHandler.processError(error);
        }
    }

    generateReports() {
        window.scrollTo(0, 0);

        this.showSpinner = true;
        var reportGenerateParams = this.getGenerateRequestParams();
        this._reportService.generateReports(reportGenerateParams)
            .subscribe(
                (res) => {
                    console.log('queued: ' + res);
                    this.refreshReportsList();
                    this._notificationsService.add(new Notification('success', 'Your report has been submitted for processing, please check the status below or hit the refresh button to update its status'));
                },
                (error: any) => {
                    this.showSpinner = false;
                    if (this.isAntiXssError(error)) {
                        this._notificationsService.add(new Notification('error', this._errorHandler.xssMessage));
                    } else {
                        this.processError(error);
                    }
                }
            );

    }

    private getGenerateRequestParams(): ReportBuilder {
        const reportGenerateParams = this.getRequestParams();
        reportGenerateParams.pageStartIndex = 0;
        reportGenerateParams.pageSize = this.REPORTS_PAGE_SIZE;
        reportGenerateParams.totalNumberOfRecords = 0;
        return reportGenerateParams;
    }

    private isAntiXssError(error: any): boolean {
        const serialized = typeof error === 'string' ? error : JSON.stringify(error);
        return serialized.indexOf('AntiXssMiddleware') !== -1;
    }
    refreshReportsList() {
        this.showSpinner = true;
        this.isLoadingMoreRecords = false;
        this.reportParams.pageStartIndex = 0;
        this.reportParams.pageSize = this.REPORTS_PAGE_SIZE;
        var reportGenerateParams = this.getRequestParams();
        this._reportService.getReportsList(reportGenerateParams)
            .subscribe(
                (res) => {
                    this.ngZone.run(() => {
                        this.applyReportsList(res);
                        this.scheduleReportsViewRefresh();
                    });
                },
                (error: any) => {
                    this.ngZone.run(() => {
                        this.reportParams.reports = [];
                        this.showSpinner = false;
                        this.processError(error);
                        this.scheduleReportsViewRefresh();
                    });
                }
            );
    }

    getReport(item: IReportItem): void {
        var self = this;
        this.showSpinner = true;
        var reportGenerateParams = this.getRequestParams();
        reportGenerateParams.reportId = item.reportId;
        this._reportService.getReportsItem(reportGenerateParams)
            .subscribe(
                (res) => {
                    this._http.get(res.reportUrl, { responseType: 'blob' }).pipe(
                    ).subscribe(
                        (blob: Blob) => {
                        this.ngZone.run(() => this._fileDownloadService.downloadFile(blob, this.getReportFileName(res)));
                        },
                        (error) => {
                            this.ngZone.run(() => this.processError(error));
                        }
                    );
                },
                (error: any) => {
                    this.processError(error);
                }
            );

    }

    getReportFileName(item: IReportItem): string{
        switch(item.reportName) { 
            case "masterReport": { 
                return item.projectName + "_Master_" + item.status + ".pdf";
            } 
            case "masterReferenceReport": { 
                return item.projectName + "_Master With Reference_" + item.status + ".pdf";
            }
            case "masterReportHorizontal": { 
                return item.projectName + "_Master Horizontal_" + item.status + ".pdf";
            } 
            case "endCreditsReport": { 
                return item.projectName + "_Distribution Memos_" + item.restrictionType + "." + item.fileFormat;
            } 
            default: { 
                return item.projectName + "_" + item.reportName + ".pdf";
            }
        }
    }


    getRequestParams(): ReportBuilder {
        var reportGenerateParams = <ReportBuilder>Object.assign({}, this.reportParams);
        if (!reportGenerateParams.searchByValue)
            reportGenerateParams.searchBy = 'All';

        reportGenerateParams.reports = [];
        reportGenerateParams.asOfDate = DateUtils.toApiDate(reportGenerateParams.asOfDate);

        //to minimize the payload send only either selected or unselected (service should be able to figure it out)
        if (this.tagComponent && this.includeAllTags) {
           
            let selectedTags = this.tagComponent.getSelectedTags();
            var selectedItems = [];
            if(selectedTags.length > 0){
                selectedItems = selectedTags.map(t => t.tagId);
            }
           
            var unselectedTags =[];
            unselectedTags = this.tagComponent.globalTags.filter(t => {
                return !selectedItems.find(s => s == t.tagId);
            });

            let allTagsCount = this.tagComponent.globalTags.length;
            if (unselectedTags.length != allTagsCount && selectedTags.length != allTagsCount ) {
                if (unselectedTags.length > selectedItems.length)
                    reportGenerateParams.includeTheseTags = selectedItems;//.map(s=> `'${s}'`).join(',');        
                else
                    reportGenerateParams.excludeTheseTags = unselectedTags.map(ut => ut.tagId);// `'${ut.tagId}'`).join(',');
            }
        }

        return reportGenerateParams;
    }

    reportItemClicked(item: IReportItem): void {
        this.reportItemMessage = '';
        this.reportItemMessageTitle = '';
        if (item.reportStatus == this.REPORT_GENERATED_SUCCESSFULLY) {
            this.getReport(item);
        }
        else if (item.reportStatus == this.REPORT_WITH_ERROR || item.errorMessage) {
            this.reportItemMessage = item.errorMessage;
            this.reportItemMessageTitle = 'Error';
            this.openStatusModal();
        }
        else {
            this.reportItemMessage = 'The system is generating the report, please click on the Refresh button.';
            this.reportItemMessageTitle = 'In Progress';
            this.openStatusModal();
        }
    }

    clearParameters() {
        this.reportParams.sortedBy = '';
        this.reportParams.sortDirection = 'DESC';
        this.reportParams.searchByValue = '';


        this.reportParams.status = this.statusLookup[0].id;
        this.reportParams.restrictionType = this.restrictionsLookup[0].name;
        this.reportParams.searchBy = 'All';
        this.reportParams.isCustomHeaderSelected=false;
        this.reportParams.customHeader='';
    }

    filterChanged(filterType: string): void {
        window.scrollTo(0, 0);

        if (filterType == 'clear') {
            this.reportParams.searchByValue = '';
            this.reportParams.searchBy = 'All';
        }
        if (filterType == 'searchBy') {
            if (this.reportParams.searchBy == 'All')
                this.reportParams.searchByValue = '';
        }
    }

    loadCILookups(projectId: string): void {
        this._appService.retrieveCILookups('CIStatus,CIRestrictions', projectId)
            .subscribe(
                (list) => {
                    if (list) {
                        this.onLookupsRetrieved(list);
                    }
                },
                (error) => {

                }
            );

    }
    onLookupsRetrieved(list: LookupList[]): void {
        if (list && list.length > 0) {
            this.statusLookup = [];
            this.restrictionsLookup = [];

            if (list.find(it => it.lookupType == 'CIStatus') != null && list.find(it => it.lookupType == 'CIStatus').lookupData) {
                list.find(it => it.lookupType == 'CIStatus').lookupData.forEach(look => this.statusLookup.push(look));
                
                let firstLookup = new ILookup('All', 'All');
                this.statusLookup.splice(0, 0, firstLookup);

                let staticLookup;
                if(!this._authService.secondApproval){
                    staticLookup = new ILookup('Urgent', 'Urgent');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Pending', 'All Pending');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                    staticLookup = new ILookup('All Clear', 'All Clear');
                    this.statusLookup.splice(this.statusLookup.length, 0, staticLookup);
                }
            }
            if (list.find(it => it.lookupType == 'CIRestrictions') != null && list.find(it => it.lookupType == 'CIRestrictions').lookupData) {
                list.find(it => it.lookupType == 'CIRestrictions').lookupData.forEach(look => this.restrictionsLookup.push(look));
                this.reportParams.restrictionType = this.restrictionsLookup[0].name;
            }
        }

    }

    deleteReportClicked(item: IReportItem): void {
        this._reportService.deleteReport(item.reportId)
            .subscribe(
                (r) => {
                    this.ngZone.run(() => {
                        if (!r) {
                            return;
                        }
                        console.log('deleteReportClicked(...) >> response: ' + JSON.stringify(r));
                        this.refreshReportsList();
                        this._notificationsService.add(new Notification('success', 'Your report has been deleted successfully.'));
                    });
                },
                (error: any) => {
                    // console.error('deleteReportClicked(...) >> error:' + error);
                    this._errorHandler.processError(error);
                }

            );


    }



    openDeleteConfirmationModal(item: IReportItem) {
        let promptOptions: PromptOptions = { header: 'Delete Report', body: '' };
        this.collapseAll();

        promptOptions.body = 'Are you sure you want to delete the selected report?';
        this._prompt.openModal(null, true, promptOptions).pipe(first())
            .subscribe(
                answerIsYes => {
                    if (answerIsYes) {
                        this.deleteReportClicked(item);
                        this.collapseAll();
                    }
                });

        return false;
    }

    collapseAll(): void {
        this.mobileFiltersExpanded = false;
    }

    get IsMasterReport(): boolean {
        return this.reportParams.reportName == this.MASTER_REPORT_NAME || this.reportParams.reportName == this.MASTER_REFERENCE_REPORT_NAME || this.reportParams.reportName == this.MASTER_REPORT_HORIZONTAL_NAME
    }

    public onIncludeAllTagsChanged(yesPlease: boolean, _force: boolean = false) {
        if (!this.tagComponent) {
            return;
        }
        if (yesPlease) {
            console.log('retrieving all tags pertaining in this criteria');
            this.isLoadingFilterTags = true;
            this.loadTagLookups();
            return;
        }
        this.isLoadingFilterTags = false;
        this.globalTags = [];
        this.tagComponent.updateTags([]);
    }

    private syncFilterTagsWithProject(): void {
        if (!this.IsMasterReport) {
            return;
        }
        if (!this.tagComponent) {
            setTimeout(() => this.syncFilterTagsWithProject(), 50);
            return;
        }
        const projectId = this.reportParams && this.reportParams.projectId;
        if (!projectId) {
            return;
        }
        this.tagComponent.projectId = projectId;
        if (this.includeAllTags) {
            this.onIncludeAllTagsChanged(true);
            return;
        }
        this.tagComponent.loadTagLookups();
    }
    public onCustomHeaderSelectionChanged(option:boolean)
    {
        if(option)
        {
            this.reportParams.asOfDate = new Date();
            this.reportParams.customHeader=`Unless otherwise indicated, this status report addresses use in the film only.  Should any merchandise (books, toys, food products, video games, clothing, etc.) or product packaging be produced bearing items referenced here, additional review will be required.  When discussing status we will generally use the following terms with critical distinctions: \n \n Permissible -- Item has been assessed.  No permission is necessary as presently scripted and/or for currently proposed context. \n \n Clear -- Permission has been granted for use as currently scripted/proposed only. \n \n NOT CLEAR -- May not be used.`;
        }
        else{
            this.reportParams.asOfDate=null;
            this.reportParams.customHeader="";
        }
        this.scheduleCustomHeaderResize();
    }

    private scheduleCustomHeaderResize(): void {
        setTimeout(() => {
            if (this.customHeaderAutosize) {
                this.customHeaderAutosize.resizeToFitContent(true);
            }
        });
    }

    loadTagLookups(): void {
        var reportGenerateParams = this.getRequestParams();
        this._reportService.getTags(reportGenerateParams)
            .subscribe(
                (list) => {
                    this.onTagsRetrieved(list);
                },
                (error: any) => {
                    this.isLoadingFilterTags = false;
                    this.globalTags = [];
                    console.error('loadCILookups(...):' + error);
                }
            );

    }
    onTagsRetrieved(list: ILookup[]): void {
        this.ngZone.run(() => {
            this.isLoadingFilterTags = false;
            this.globalTags = [];
            if (list) {
                list.forEach(lookup => {
                    var ciTag: CITag = new CITag();
                    ciTag.tagId = lookup.id;
                    ciTag.tagName = lookup.name;
                    ciTag.tagType = lookup.type;
                    ciTag.icon = 'bookmark';
                    ciTag.isSelected = true;
                    this.globalTags.push(ciTag);
                });
            }
            if (this.tagComponent) {
                this.tagComponent.updateTags(this.globalTags);
            }
            this.scheduleReportsViewRefresh();
        });
    }

    newTagAdded(tag: FormGroup): void {
        if (tag) {
            tag.controls.isSelected.setValue(!tag.controls.isSelected.value);
        }
    }

    refreshParams(e){
        this.onIncludeAllTagsChanged(this.includeAllTags, true)
    }

    setToolTipDelay(){
        const container = document.getElementById('cardListDivContainer');
        let self = this;
        if (container) {
            const divsSearchBy = container.querySelectorAll('.searchByToolTip');
            const divsSearchByArray = Array.from(divsSearchBy);
            divsSearchByArray.forEach((div: HTMLDivElement) => {
                let report = self.reportParams.reports.find(r => r.createdDate == (div.nextElementSibling.firstChild.nextSibling as HTMLDivElement).innerText);
                if (report){
                    report.toolTipSearchByDelay = 5000;
                    if ((div.scrollWidth > div.clientWidth)){
                        report.toolTipSearchByDelay = 500;
                    }
                }
            });
            const divsStatus = container.querySelectorAll('.statusToolTip');
            const divsStatusArray = Array.from(divsStatus);
            divsStatusArray.forEach((div: HTMLDivElement) => {
                let report = self.reportParams.reports.find(r => r.createdDate == (div.nextElementSibling.nextElementSibling.firstChild.nextSibling as HTMLDivElement).innerText);
                if (report){
                    report.toolTipStatusDelay = 5000;
                    if ((div.scrollWidth > div.clientWidth)){
                    report.toolTipStatusDelay = 500;
                    }
                }
            });
        }
    }

    private openStatusModal(): void {
        this._dialog.open(ReportsStatusDialogComponent, {
            width: '500px',
            disableClose: true,
            data: {
                title: this.reportItemMessageTitle,
                message: this.reportItemMessage
            }
        });
    }

}

@Component({
  selector: 'reports-status-dialog',
  standalone: false,
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p>{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Ok</button>
    </mat-dialog-actions>
  `
})
export class ReportsStatusDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
